// VFX: Stat Counter Hero
// Category: data-viz  ·  Tags: counter, stat, hero, number, spring
// Large animated number hero — spring easing, glow on final value.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
  spring,
  interpolate,
} from "remotion";
import React from "react";

const clamp = {
  extrapolateLeft: "clamp",
  extrapolateRight: "clamp",
} as const;

export default function DataStatCounterHeroAnimated1200Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const target = 1247;
  const p = spring({
    frame,
    fps,
    config: { damping: 80, stiffness: 140, mass: 1 },
  });
  const value = Math.round(interpolate(p, [0, 1], [0, target], clamp));
  const labelOpacity = interpolate(frame, [12, 24], [0, 1], clamp);
  const glow = interpolate(p, [0.85, 1], [0, 1], clamp);
  return (
    <AbsoluteFill
      style={{
        background:
          "radial-gradient(ellipse at 50% 45%, #1e293b 0%, #0a0e1a 70%)",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: 1200,
          height: 1200,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(168,85,247,0.35) 0%, transparent 60%)",
          opacity: glow,
          filter: "blur(20px)",
        }}
      />
      <div
        style={{
          fontSize: 280,
          fontWeight: 900,
          color: "#f8fafc",
          letterSpacing: "-8px",
          lineHeight: 1,
          textShadow: `0 0 ${60 * glow}px rgba(168,85,247,${0.7 * glow})`,
          transform: `scale(${interpolate(p, [0, 1], [0.7, 1], clamp)})`,
          zIndex: 1,
        }}
      >
        {value.toLocaleString()}
      </div>
      <div
        style={{
          marginTop: 24,
          fontSize: 36,
          fontWeight: 500,
          color: "#94a3b8",
          letterSpacing: 4,
          textTransform: "uppercase",
          opacity: labelOpacity,
          zIndex: 1,
        }}
      >
        Active users
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
